import React, { useState } from 'react';
import Select from 'react-select';

const CouponModal = ({ isOpen, setIsOpen, statusOptions, handleSubmit, couponform, handleChange, setCouponForm, loadButton }) => {

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Coupon Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="coupon" className="oms-form-label">
                            Coupon
                        </label>
                        <input
                            type="text"
                            id="Coupon"
                            name='Coupon'
                            value={couponform.Coupon}
                            onChange={handleChange}
                            placeholder="Enter coupon code"
                        />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">
                            Description
                        </label>
                        <input
                            type="text"
                            id="description"
                            name='description'
                            value={couponform.description}
                            onChange={handleChange}
                            placeholder="Enter description"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="percentage_offer" className="oms-form-label">
                            Discount (%)
                        </label>
                        <input
                            type="number"
                            id="percentage_offer"
                            name='percentage_offer'
                            value={couponform.percentage_offer}
                            onChange={handleChange}
                            placeholder="Enter discount percentage"
                            onWheel={(e) => e.target.blur()}
                            disabled={couponform.price_offer !== ""}
                            style={{ backgroundColor: couponform.price_offer !== "" ? '#f0f0f0' : 'white' }}
                        />

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="price_offer" className="oms-form-label">
                            Price Discount
                        </label>

                        <input
                            type="number"
                            id="price_offer"
                            name="price_offer"
                            value={couponform.price_offer}
                            onChange={handleChange}
                            placeholder="Enter price discount"
                            onWheel={(e) => e.target.blur()}
                            disabled={couponform.percentage_offer !== ""}
                            style={{ backgroundColor: couponform.percentage_offer !== "" ? '#f0f0f0' : 'white' }}
                        />
                    </div>
                    {
                        couponform.percentage_offer !== "" &&
                        <div className="oms-form-group">
                            <label htmlFor="dicount_percentage_price" className="oms-form-label">
                                Discount Upto
                            </label>

                            <input
                                type="number"
                                id="dicount_percentage_price"
                                name="dicount_percentage_price"
                                value={couponform.dicount_percentage_price}
                                onChange={handleChange}
                                placeholder="Enter Discount upto"
                                onWheel={(e) => e.target.blur()}
                            // disabled={couponform.percentage_offer !== ""}
                            // style={{ backgroundColor: couponform.dicount_percentage_price !== "" ? '#f0f0f0' : 'white' }}
                            />
                        </div>
                    }
                    <div className="oms-form-group">
                        <label htmlFor="start" className="oms-form-label">
                            Start Date
                        </label>
                        <input
                            type="date"
                            id="start"
                            name='start'
                            value={couponform.start}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="end" className="oms-form-label">
                            End Date
                        </label>
                        <input
                            type="date"
                            id="end"
                            name='end'
                            value={couponform.end}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="used_by" className="oms-form-label">
                            Coupon Usage
                        </label>
                        <input
                            type="number"
                            id="used_by"
                            name='used_by'
                            value={couponform.used_by}
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                            placeholder="Enter coupon usage limit"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="price_upto" className="oms-form-label">
                            Minimum Order Value
                        </label>
                        <input
                            type="number"
                            id="price_upto"
                            name="price_upto"
                            value={couponform.price_upto}
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                            placeholder="Enter the minimum order value for this coupon"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="price_upto" className="oms-form-label">
                            User Discount Limit
                        </label>
                        <input
                            type="number"
                            id="user_discount_limit"
                            name="user_discount_limit"
                            value={couponform.user_discount_limit}
                            onChange={handleChange}
                            onWheel={(e) => e.target.blur()}
                            placeholder="Enter the User Discount Limit"
                        />
                    </div>


                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        {/* <Select
                            id="status"
                            options={statusOptions}
                            onChange={(selectedOption) =>
                                setCouponForm((prev) => ({ ...prev, status: selectedOption }))
                            }
                            placeholder="Select status"
                        /> */}
                        <Select
                            id="status"
                            options={statusOptions}
                            value={statusOptions.find(option => option.value === couponform.status?.value || couponform.status)}
                            onChange={(selectedOption) =>
                                setCouponForm((prev) => ({ ...prev, status: selectedOption }))
                            }
                            placeholder="Select status"
                        />
                        <div className="oms-form-group checkbox-group">
                            <input
                                type="checkbox"
                                id="show_to_user"
                                name="show_to_user"
                                checked={couponform.show_to_user}
                                onChange={(e) =>
                                    setCouponForm({
                                        ...couponform,
                                        show_to_user: e.target.checked,
                                    })
                                }
                            />
                            <label htmlFor="show_to_user">Show to user</label>
                        </div>
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        {
                            loadButton ?<button type="button">Submiting...</button>:
                            <button type="submit">Submit</button>
                        }
                        
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CouponModal;
